"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHeight = exports.getWidth = exports.spacing = exports.pxToRem = exports.getFocusStyles = exports.flexPosition = void 0;
const flexPosition = (align, justify, flexDirection, alignSelf, justifySelf) => `
  display: flex;
  ${align ? `align-items: ${align};` : ''}
  ${justify ? `justify-content: ${justify};` : ''};
  ${flexDirection ? `flex-direction: ${flexDirection};` : ''};
  ${alignSelf ? `align-self: ${alignSelf};` : ''};
  ${justifySelf ? `justify-self: ${justifySelf};` : ''};
`;
exports.flexPosition = flexPosition;
const getFocusStyles = (background) => `
  position: relative;
  &:after {
    content: '';
    position: absolute;
    bottom: 4px;
    left: 6px;
    background-color: ${background};
    width: calc(100% - 11px);
    height: 2px;
  }
`;
exports.getFocusStyles = getFocusStyles;
const pxToRem = (px) => `${px / 16}rem`;
exports.pxToRem = pxToRem;
const spacing = (spacing) => (0, exports.pxToRem)(spacing * 8);
exports.spacing = spacing;
const getWidth = (props) => {
    const { width, fullWidth, fullScreen } = props;
    if (fullScreen)
        return '100vw';
    if (fullWidth)
        return '100%';
    if (width)
        return typeof width === 'number' ? (0, exports.pxToRem)(width) : width;
    return 'auto';
};
exports.getWidth = getWidth;
const getHeight = (props) => {
    const { height, fullHeight, fullScreen } = props;
    if (fullScreen)
        return '100vh';
    if (fullHeight)
        return '100%';
    if (height)
        return typeof height === 'number' ? (0, exports.pxToRem)(height) : height;
    return 'auto';
};
exports.getHeight = getHeight;
//# sourceMappingURL=mixins.js.map